import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Coupon } from 'app/public/model/coupon.model';

@Component({
  selector: 'app-roulette-coupons-settings-item',
  templateUrl: './roulette-coupons-settings-item.component.html',
  styleUrls: ['./roulette-coupons-settings-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouletteCouponsSettingsItemComponent implements OnInit {
  @Input() coupon: Coupon;
  @Input() index: number;
  @Input() iconsList: { Id: number, Url: string }[];
  @Input() form: NgForm;

  displayLink: boolean;
  coponTextMaxLength = 50;

  constructor() { }

  ngOnInit(): void {
  }
  toggleLink() {
    this.displayLink = !this.displayLink;

  }
  isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }
  changeCouponIcon(coupon, icon) {
    coupon.IconUrl = icon.Url;
    coupon.IconId = icon.Id;
    this.form.form.markAsDirty();
  }
}
